import {
  type GetSignedUrlFn,
  type GetSignedUrlFnParams,
  useUploadFileMutation,
} from "@/axios/mutations/use-upload-file.mutation";
import { generateCommentAttachmentUploadUrl } from "@/spz-api/control-result-comments/control-result-comments";
import type { GenerateCommentAttachmentUploadUrlRequestDtoContentType } from "@/spz-api/model";
import { HARD_LIMITS } from "@spz/config";

export const useUploadCommentAttachmentMutation = ({
  controlId,
  controlResultId,
}: {
  controlId: string;
  controlResultId: string;
}) => {
  const getSignedUrl: GetSignedUrlFn = async ({
    file,
    data,
  }: GetSignedUrlFnParams) => {
    const contentType =
      file.type as GenerateCommentAttachmentUploadUrlRequestDtoContentType;

    const signedUrlResponse = await generateCommentAttachmentUploadUrl(
      controlId,
      controlResultId,
      {
        md5Hash: data.md5Hash,
        contentType,
        fileName: data.fileName,
        fileSize: file.size,
      },
    );

    return {
      uploadUrl: signedUrlResponse.uploadUrl,
      id: signedUrlResponse.id,
    };
  };

  return useUploadFileMutation({
    maxFileSize: HARD_LIMITS.comments.attachmentMaxSize,
    getSignedUrl,
  });
};
